/**
 * ChooseApplicationModalPanel
 * Panel-layer wrapper for the choose-application action.
 * Receives params: { unitId } from the WorkflowPanelProvider modal registry.
 *
 * Opens the LinkApplicationPicker in a modal context so the landlord can bind
 * an accepted application from any screen.
 */

import { useQueryClient } from '@tanstack/react-query';
import { Modal } from '../../Modal';
import { LinkApplicationPicker } from '../../move-in/LinkApplicationPicker';

interface ChooseApplicationModalPanelProps {
  params: Record<string, string>;
  onClose: () => void;
}

export function ChooseApplicationModalPanel({ params, onClose }: ChooseApplicationModalPanelProps) {
  const { unitId } = params;
  const queryClient = useQueryClient();

  if (!unitId) return null;

  const handleLinked = () => {
    void queryClient.invalidateQueries({ queryKey: ['workflows'] });
    onClose();
  };

  return (
    <Modal isOpen={true} onClose={onClose} title="Choose Application">
      <p className="text-sm text-muted-foreground mb-4">
        Select an approved application to link to this move-in workflow.
      </p>
      <LinkApplicationPicker unitId={unitId} onLinked={handleLinked} />
    </Modal>
  );
}
